module.exports = __webpack_public_path__ + "media/images/party-766f6ba12c71e66b7f6830a054f8e818.png";